import React, { useEffect, useState } from "react";
import { SubToPages_pages } from "../../api/SubToPages";
import { SliderFontSizeProvider } from "../SliderFontSize/context";
import EditingRouter from "./EditingRouter";
import { useNavigate } from "react-router";

type Props = {
  projectId: string;
  pages: SubToPages_pages[];
  loading: boolean;
};

const EditingRouterProvider = (props: Props) => {
  const navigate = useNavigate();
  const [initialSearch] = useState(window.location.search);

  // Push search route to navigate using timeout: the search is erased automatically somewhere
  useEffect(() => {
    if (initialSearch) {
      setTimeout(() => {
        navigate(window.location.pathname + initialSearch);
      }, 100);
    }
  }, [initialSearch, navigate]);

  return (
    <SliderFontSizeProvider>
      <EditingRouter {...props} />
    </SliderFontSizeProvider>
  );
};

export default EditingRouterProvider;
